import { Model } from './model'

export class AppInfo extends Model {
  iconUrl: string // absolute or relative path to icon
  app: string // app kebab-case name
  title: string
  color: string // main app color
  appUrl: string
  options: any

  constructor(obj = {}) {
    super(obj)
  }
}
